<template>
    <div class="page page-footprint" v-if="yearData">
        <div class="page-footprint-item page-footprint-01 show">
            <div class="bg">
                <div class="cloud-01">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
                <div class="cloud-02">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
                <div class="cloud-03">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
            </div>
            <div class="page-inner">
                <div class="main">
                    <div class="main-item">
                        <h4>
                            <img src="../assets/img/foot_title.png" alt="">
                        </h4>
                        <p>这一年</p>
                        <p>你打开封面新闻<span>{{yearData.use_count}}</span>次</p>
                        <p>有<span>{{yearData.use_days}}</span>天，都在使用封面新闻了解世界</p>
                        <p>用了<span>{{yearData.use_time}}</span>分的时间，与封面新闻一起成长</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footprint-item page-footprint-02">
            <div class="bg">
                <div class="cloud-01">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
                <div class="cloud-02">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
            </div>
            <div class="page-inner">
                <div class="main">
                    <div class="main-item">
                        <p>这一年</p>
                        <p>你阅读了<span>{{yearData.news_read_cnt}}</span>篇新闻，观看了<span>{{yearData.live_view_cnt}}</span>场直播</p>
                        <p>发表了<span>{{yearData.discuss_cnt}}</span>条评论，转发了<span>22</span>篇内容</p>
                        <p>点赞<span>{{yearData.like_cnt}}</span>次</p>
                        <p>发布了<span>{{yearData.dynamic_pub_cnt}}</span>条动态内容</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footprint-item page-footprint-03">
            <div class="bg">
                <div class="bird">
                    <img src="../assets/img/bird.png" alt="">
                </div>
                <div class="cloud-02">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
            </div>
            <div class="page-inner">
                <div class="main">
                    <div class="main-item">
                        <p>这一年</p>
                        <p>你在封面新闻获得<span>{{yearData.score_get_num}}</span>积分</p>
                        <p>参与了<span>{{yearData.enjoy_party_times}}</span>次互动活动</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footprint-item page-footprint-04">
            <div class="bg">
                <div class="cloud-01">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
                <div class="cloud-02">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
            </div>
            <div class="page-inner">
                <div class="main">
                    <div class="main-item">
                        <p>这一年</p>
                        <p v-if="yearData.use_time_early"><span>{{yearData.use_time_early[1]}}</span>月<span>{{yearData.use_time_early[2]}}</span>日<span>{{yearData.use_time_early[3]}}</span>时<span>{{yearData.use_time_early[4]}}</span>分</p>
                        <p>是你今年最早阅读时刻</p>
                        <p v-if="yearData.use_time_lately"><span>{{yearData.use_time_lately[1]}}</span>月<span>{{yearData.use_time_lately[2]}}</span>日<span>{{yearData.use_time_lately[3]}}</span>时<span>{{yearData.use_time_lately[4]}}</span>分</p>
                        <p>是你今年最晚阅读时刻</p>
                        <p v-if="yearData.last_arrive_date"><span>{{yearData.last_arrive_date[1]}}</span>月<span>{{yearData.last_arrive_date[2]}}</span>日<span>{{yearData.last_arrive_date[3]}}</span>时<span>{{yearData.last_arrive_date[4]}}</span>分</p>
                        <p>是你今年最后一次使用时间</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footprint-item page-footprint-05">
            <div class="bg">
                <div class="cloud-01">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
                <div class="cloud-02">
                    <img src="../assets/img/cloud.png" alt="">
                </div>
            </div>
            <div class="page-inner">
                <div class="main">
                    <div class="main-item">
                        <p>这每一个微妙的时刻</p>
                        <p>封面新闻都帮你记得</p>
                        <p v-if="yearData.channel_label">这一年</p>
                        <p v-if="yearData.channel_label">你的阅读口味包含了</p>
                        <div class="tag-wrapper" v-if="yearData.channel_label">
                            <div class="user-img">
                                <img :src="userInfo.avatar || 'https://wapcdn.thecover.cn/wap/4.2.1/images/user_default.png'" alt="">
                            </div>
                            <div class="tags">
                                <span v-for="item in yearData.channel_label">{{item}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main-item hide">
                        <p><span><b>2</b><b>0</b><b>2</b><b>0</b></span></p>
                        <p><b>感</b><b>谢</b><b>你</b><b>的</b><b>使</b><b>用</b></p>
                        <p><span><b>2</b><b>0</b><b>2</b><b>1</b></span></p>
                        <p><b>我</b><b>们</b><b>依</b><b>然</b><b>是</b><b>彼</b><b>此</b><b>最</b><b>温</b><b>暖</b><b>的</b><b>陪</b><b>伴</b></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="arrow-btn" @click="changeData('')" v-if="btnShow">
            <img src="../assets/img/data_arrow.png" alt="">
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Ball from '@/utils/ball'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

import HongBao from '@/components/HongBao.vue'

@Options({
    data () {
        return {
            currentIndex: 0,
            textBall: null,
            btnShow: true,
            timeId1: null,
            timeId2: null
        }
    },
    components: {
        HongBao
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'yearData', 'activityData'])
    },
    beforeUnmount () {
        clearTimeout(this.timeId1)
        clearTimeout(this.timeId2)
        this.currentIndex = 0
        this.changeData(0)
    },
    mounted () {
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_HBDATA']),
        changeData (index?: number | string): void {
            if (!this.yearData) {
                return
            }
            const items = document.querySelectorAll('.page-footprint-item') as NodeListOf<HTMLElement>
            if (index !== 0) {
                this.currentIndex++
            }
            if (this.currentIndex === items.length) {
                const showDom = document.querySelector('.page-footprint-05 .main-item') as HTMLElement
                const hideDom = document.querySelector('.page-footprint-05 .main-item.hide') as HTMLElement
                showDom.className = 'main-item hide'
                hideDom.className = 'main-item'
                this.textBall && this.textBall.destroy()
                this.btnShow = false
                this.timeId1 = setTimeout(() => {
                    const hideDom = document.querySelectorAll('.page-footprint-05 .main-item')[1] as HTMLElement
                    hideDom.className = 'main-item leave'
                    this.timeId2 = setTimeout(() => {
                        this.SET_HBDATA(true)
                    }, 3000)
                }, 3000)
                return
            }
            items.forEach((node: HTMLElement, idx: number) => {
                let classNameArr: Array<string> = node.className.split(' ')
                let showIndex: number = classNameArr.indexOf('show')
                let hideIndex: number = classNameArr.indexOf('hide')
                showIndex > -1 && classNameArr.splice(showIndex, 1)
                hideIndex > -1 && classNameArr.splice(hideIndex, 1)
                let className:string = classNameArr.join(' ')
                if (this.currentIndex === idx) {
                    node.className = `${className} show`
                    if (this.currentIndex === items.length - 1 && this.yearData.channel_label) {
                        this.textBall = new Ball({
                            wrapper: '.page-footprint .tags'
                        })
                    }
                } else if (this.currentIndex - 1 === idx) {
                    node.className = `${className} hide`
                } else {
                    node.className = className
                }
            })
        }
    }
})
export default class FootPrint extends Vue {}
</script>

<style lang="scss">
.page-footprint {
    font-size: 0;
    height: 100%;
    background-color: #fcfcfc;
    overflow-x: hidden;
    position: relative;
    .page-footprint-item {
        height: 100%;
        background: url('../assets/img/foot_01_bg.jpg') no-repeat center bottom;
        background-size: 100% auto;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        display: none;
        &.page-footprint-02 {
            background-image: url('../assets/img/foot_02_bg.jpg');
            .page-inner {
                padding: 3.333333rem 1.203704rem 0 1.462963rem;
            }
        }
        &.page-footprint-03 {
            background-image: url('../assets/img/foot_03_bg.jpg');
            .page-inner {
                padding-top: 3.425926rem;
                p {
                    animation-name: backInRight;
                }
                .main {
                    .main-item {
                        text-align: right;
                    }
                }
            }
        }
        &.page-footprint-04 {
            background-image: url('../assets/img/foot_04_bg.jpg');
            .page-inner {
                padding: 5.740741rem 1.203704rem 0 1.574074rem;
            }
            .bg {
                .cloud-01 {
                    top: 1.342593rem;
                    left: 5.259259rem;
                }
                .cloud-02 {
                    top: 3.75rem;
                    right: auto;
                    left: 2.296296rem;
                }
            }
        }
        &.page-footprint-05 {
            background-image: url('../assets/img/foot_05_bg.jpg');
            .page-inner {
                padding: 2.314815rem 1.203704rem 0;
                .main {
                    .main-item {
                        text-align: center;
                        &.hide {
                            display: none;
                        }
                        p {
                            animation-name: fadeInDown;
                        }
                        &:nth-of-type(2) {
                            padding-top: 1.388889rem;
                            p {
                                animation: fadeIn 1s forwards;
                                b {
                                    display: inline-block;
                                    font-weight: normal;
                                    animation: zoomInDown 1s forwards;
                                    &:nth-of-type(2) {
                                        animation-duration: 1.2s;
                                    }
                                    &:nth-of-type(3) {
                                        animation-duration: 1.4s;
                                    }
                                    &:nth-of-type(4) {
                                        animation-duration: 1.6s;
                                    }
                                    &:nth-of-type(5) {
                                        animation-duration: 1.8s;
                                    }
                                    &:nth-of-type(6) {
                                        animation-duration: 2s;
                                    }
                                    &:nth-of-type(7) {
                                        animation-duration: 2.2s;
                                    }
                                    &:nth-of-type(8) {
                                        animation-duration: 2.4s;
                                    }
                                    &:nth-of-type(9) {
                                        animation-duration: 2.6s;
                                    }
                                    &:nth-of-type(10) {
                                        animation-duration: 2.8s;
                                    }
                                    &:nth-of-type(11) {
                                        animation-duration: 3s;
                                    }
                                    &:nth-of-type(12) {
                                        animation-duration: 3.2s;
                                    }
                                    &:nth-of-type(13) {
                                        animation-duration: 3.4s;
                                    }
                                }
                            }
                        }
                        &.leave {
                            p {
                                animation-name: none;
                                b {
                                    animation: zoomOutUp 1s forwards;
                                    &:nth-of-type(2) {
                                        animation-delay: .2s;
                                    }
                                    &:nth-of-type(3) {
                                        animation-delay: .4s;
                                    }
                                    &:nth-of-type(4) {
                                        animation-delay: .6s;
                                    }
                                    &:nth-of-type(5) {
                                        animation-delay: .8s;
                                    }
                                    &:nth-of-type(6) {
                                        animation-delay: 1s;
                                    }
                                    &:nth-of-type(7) {
                                        animation-delay: 1.2s;
                                    }
                                    &:nth-of-type(8) {
                                        animation-delay: 1.4s;
                                    }
                                    &:nth-of-type(9) {
                                        animation-delay: 1.6s;
                                    }
                                    &:nth-of-type(10) {
                                        animation-delay: 1.8s;
                                    }
                                    &:nth-of-type(11) {
                                        animation-delay: 2s;
                                    }
                                    &:nth-of-type(12) {
                                        animation-delay: 2.2s;
                                    }
                                    &:nth-of-type(13) {
                                        animation-delay: 2.4s;
                                    }
                                }
                            }
                        }
                    }
                    .tag-wrapper {
                        position: relative;
                        .user-img {
                            width: 1.5rem;
                            height: 1.5rem;
                            border-radius: 50%;
                            padding: .092593rem;
                            background-color: #ff3437;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            img {
                                border-radius: 50%;
                            }
                        }
                    }
                    .tags {
                        width: 6.481481rem;
                        height: 6.481481rem;
                        position: relative;
                        margin: 0 auto;
                        span {
                            white-space: nowrap;
                            font-size: .259259rem;
                            color: #000;
                            position: absolute;
                            left: 0;
                            top: 0;
                            display: flex;
                            align-items: center;
                            &::before {
                                content: '';
                                width: 4px;
                                height: 4px;
                                border-radius: 6px;
                                background-color: #ff3437;
                                margin-right: 3px;
                            }
                        }
                    }
                }
            }
            .bg {
                .cloud-01 {
                    top: 1.342593rem;
                    left: 5.259259rem;
                }
                .cloud-02 {
                    top: 3.564815rem;
                    right: auto;
                    left: 1.694444rem;
                }
            }
        }
        &.show {
            display: block;
            animation: fadeIn 1.5s forwards;
        }
        &.hide {
            display: block;
            animation: fadeOut 1.5s forwards;
            .page-inner {
                animation: backOutLeft 1s forwards;
            }
        }
    }
    .page-inner {
        position: relative;
        z-index: 1;
        padding: 2.916667rem 1.203704rem 0 1.388889rem;
        h4 {
            animation: flipInX 1.5s forwards;
        }
        p {
            animation: backInLeft 2s forwards;
            &:nth-of-type(2) {
                animation-duration: 2.2s;
            }
            &:nth-of-type(3) {
                animation-duration: 2.4s;
            }
            &:nth-of-type(4) {
                animation-duration: 2.6s;
            }
            &:nth-of-type(5) {
                animation-duration: 2.8s;
            }
            &:nth-of-type(6) {
                animation-duration: 3s;
            }
            &:nth-of-type(7) {
                animation-duration: 3.2s;
            }
        }
        .main {
            position: relative;
            h4 {
                width: 7.101852rem;
                margin-bottom: 1.481481rem;
            }
            .main-item {
                width: 100%;
                position: absolute;
            }
            p {
                font-size: .37037rem;
                color: #000;
                line-height: 2;
                span {
                    color: #ff3437;
                }
            }
        }
    }
    .arrow-btn {
        cursor: pointer;
        width: 8.796vw;
        position: absolute;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        bottom: 9.444vw;
        background-color: rgba(0,0,0,.5);
        border-radius: 50%;
        animation: arrowbeat 1.2s alternate infinite;
    }
    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 0;
        .cloud-01 {
            position: absolute;
            width: .444444rem;
            top: 1.425926rem;
            left: 1.814815rem;
            transform: translateY(-50%);
            animation: floatupdown 2s alternate infinite;
        }
        .cloud-02 {
            position: absolute;
            width: .62963rem;
            top: 2.148148rem;
            right: 1.037037rem;
            transform: translateY(50%);
            animation: floatupdown 3s alternate infinite;
        }
        .cloud-03 {
            position: absolute;
            width: .703704rem;
            top: 5.555556rem;
            left: .814815rem;
            transform: translateY(50%);
            animation: floatupdown 3s alternate infinite;
        }
        .bird {
            width: 2.87037rem;
            position: absolute;
            top: 1.527778rem;
            left: 2.453704rem;
            transform: translateY(30%);
            opacity: 1;
            animation: floatfade 3s alternate infinite;
        }
    }
}

@keyframes arrowbeat {
    0% {
        transform: translateX(-50%) scale(1)
    }
    14% {
        transform: translateX(-50%) scale(1.2)
    }
    28% {
        transform: translateX(-50%) scale(1)
    }
    42% {
        transform: translateX(-50%) scale(1.2)
    }
    70% {
        transform: translateX(-50%) scale(1)
    }
}
</style>